import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { GlobalsStore } from '../../../stores/globals.state';
import { Button } from 'primeng/button';
import { FeatureProperties } from '../../../models/geo-data';
import { TooltipModule } from 'primeng/tooltip';
import { DataLayerStore } from '../../../stores/data-layer/data-layer.state';
import { DataLayer } from '../../../models/data-layer';
import { GridStore } from '../../../stores/grid/grid.state';
import { WidgetStore } from '../../../stores/grid/widget.state';
import { CustomGridStackWidget } from '../../../services/grid-widget-config.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-table-row-district]',
  standalone: true,
  imports: [Button, TooltipModule],
  templateUrl: './table-row-district.component.html',
  styleUrl: './table-row-district.component.scss',
})
export class TableRowDistrictComponent {
  readonly globalStore = inject(GlobalsStore);
  readonly gridStore = inject(GridStore);
  readonly widgetStore = inject(WidgetStore);
  readonly dataLayerStore = inject(DataLayerStore);
  @Input() item!: FeatureProperties;
  @Output() closeEvent = new EventEmitter<void>();

  /**
   * Closes the parent component by emitting a close event.
   *
   * @return {void} No return value.
   */
  closeParent(): void {
    this.closeEvent.emit();
  }

  /**
   * Marks or unmarks a feature in the atlas based on its presence in the selected features list.
   *
   * @param {FeatureProperties} item - The feature properties object representing the item to be marked or unmarked.
   * @return {void} This method does not return anything.
   */
  markInAtlas(item: FeatureProperties): void {
    setTimeout(() => {
      this.globalStore.triggerAtlasEvent('markDistrict', { key: item.key });
      this.closeParent();
    }, 100);
  }

  /**
   * Opens the specified item in the Atlas view.
   *
   * @param {FeatureProperties} item - The feature properties object containing details such as geographic data and keys.
   * @return {void} This method does not return a value.
   */
  openInAtlas(item: FeatureProperties): void {
    const layer: DataLayer | undefined = this.dataLayerStore
      .getLayersByGeoData(item['geoData'])
      ?.at(0);

    if (!layer) return;
    this.globalStore.setActiveReport(layer._id, item.key);
    this.closeParent();
  }
}
